'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Camps = function (_Component) {
  (0, _inherits3.default)(Camps, _Component);

  function Camps() {
    (0, _classCallCheck3.default)(this, Camps);
    return (0, _possibleConstructorReturn3.default)(this, (Camps.__proto__ || (0, _getPrototypeOf2.default)(Camps)).apply(this, arguments));
  }

  (0, _createClass3.default)(Camps, [{
    key: 'render',
    value: function render() {
      var styles = require('./Camps.scss');
      var photoIntro = require('./camps-intro.jpg');
      var photo1 = require('./camps1.jpg');
      var photo2 = require('./camps2.jpg');
      var photo3 = require('./camps3.jpg');

      var instructors = {
        tomas: {
          photo: require('./../OurTeam/tomas-krupka.jpg')
        },
        dominika: {
          photo: require('./../OurTeam/dominika-krupkova.jpg')
        }
      };

      var data = {
        dates: [{
          url: '/detske-tabory/4.-11.7.2026',
          title: 'Dětský tábor 4.-11.7.2026',
          subTitle: 'Dělej co tě baví',
          date: '4.-11.7.',
          rest: 50
        }, {
          url: '/detske-tabory/1.-8.8.2026',
          title: 'Dětský tábor 1.-8.8.2026',
          subTitle: 'Dělej co tě baví',
          date: '1.-8.8.',
          rest: 50
        }, {
          url: '/detske-tabory/8.-15.8.2026',
          title: 'Dětský tábor 8.-15.8.2026',
          subTitle: 'Dělej co tě baví',
          date: '8.-15.8.',
          rest: 50
        }],
        intro: {
          text: 'Na dětských táborech rozvíjíme u dětí sportovní dovednosti a probouzíme radost z pohybu. Každý tábor je jedinečný svým zaměřením a programem. Na všech táborech je naším cílem, aby se bavili opravdu všichni, jak začátečníci tak pokročilí.',
          image: {
            src: photoIntro,
            alt: 'Dětské tábory pro všechny'
          }
        },
        photos: {
          heading: 'Fotky z dětských táborů',
          photo1: {
            src: photo1,
            alt: 'Dětské sportovní tábory'
          },
          photo2: {
            src: photo2,
            alt: 'Letní dětské tábory'
          },
          photo3: {
            src: photo3,
            alt: 'Dětské tábory pro začátečníky i pokročilé'
          }
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: 'D\u011Btsk\xE9 t\xE1bory, na kter\xE9 se d\u011Bti r\xE1dy vrac\xED',
          meta: [{
            name: 'description',
            content: 'Dětské sportovní tábory s ubytování v krásném hotelu na horách. Pro začátečníky i malé šampiony.'
          }, {
            property: 'og:description',
            content: 'Dětské sportovní tábory s ubytování v krásném hotelu na horách. Pro začátečníky i malé šampiony.'
          }, {
            property: 'og:title',
            content: 'Dětské tábory, na které se děti rády vrací'
          }, {
            name: 'keywords',
            content: 'dětský tábor, dětský sportovní tábor, dětské sportovní tábory, letní tábor, letní tábory, letní tábory pro děti'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/detske-tabory' }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            'D\u011Btsk\xE9 t\xE1bory v roce 2026'
          ),
          _Content2.default.renderDates(styles, data.dates)
        ),
        _Content2.default.renderIntro(styles, data.intro),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _Content2.default.renderPhotos(styles, data.photos),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Co na t\xE1borech budeme d\u011Blat?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Po p\u0159\xEDjezdu na t\xE1bor rozd\u011Bl\xEDme d\u011Bti podle v\u011Bku a sportovn\xEDch dovednost\xED do skupin. Ka\u017Edou skupinu vede tren\xE9r, kter\xFD s d\u011Btmi b\u011Bhem dopoledne sportuje a u\u010D\xED je b\u011Bhat, sk\xE1kat, h\xE1zet a celkov\u011B ovl\xE1dat sv\xE9 t\u011Blo. Kombinujeme hry a specializovan\u011Bj\u0161\xED cvi\u010Den\xED, \u010D\xEDm\u017E se d\u011Bti rozv\xEDj\xED a p\u0159itom se bav\xED a nev\u011Bdomky tr\xE9nuj\xED.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'V odpoledn\xEDm programu s d\u011Btmi hrajeme celot\xE1borou hru. Jsou rozd\u011Bleny do skupin tak, aby se nau\u010Dili spolupracovat bez ohledu na v\u011Bk a sportovn\xED schopnosti. D\u016Fle\u017Eit\xE1 je souhra cel\xE9ho t\xFDmu. V pr\u016Fb\u011Bhu her se uplatn\xED jak mal\xED, tak velc\xED.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Na koho se t\u011B\u0161\xEDme?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'T\u011B\u0161\xEDme se na holky a kluky, kte\u0159\xED se s n\xE1mi cht\u011Bj\xED bavit a n\u011Bco se nau\u010Dit. Nikoho do ni\u010Deho nenut\xEDme, chceme, aby si d\u011Bti t\xE1bor u\u017Eily a nenudily se. Pokud si va\u0161e d\xEDt\u011B zvl\xE1dne samo zav\xE1zat tkani\u010Dky a nen\xED mu v\xEDc ne\u017E 15 let, t\xE1bor zvl\xE1dne levou zadn\xED.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Kde budeme ubytov\xE1ni?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'V zim\u011B jezd\xEDme s d\u011Btmi do Kru\u0161n\xFDch hor\xE1ch nedaleko J\xE1chymova, letn\xED a podzimn\xED t\xE1bory prob\xEDhaj\xED v kr\xE1sn\xE9m prost\u0159ed\xED S\xE1zavy v na\u0161em resortu. Ubytov\xE1n\xED je v\u017Edy v hotelu, zaji\u0161t\u011Bna je pln\xE1 penze a doprava z Prahy a\u017E na m\xEDsto pobytu. Vyberte si jeden z ',
                _react2.default.createElement(
                  'a',
                  { href: '#terminy', title: 'Term\xEDny d\u011Btsk\xFDch t\xE1bor\u016F' },
                  'term\xEDn\u016F'
                ),
                ' a prohl\xE9dn\u011Bte si hotel, kam jedete.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'chapter col-xs-12' },
              _react2.default.createElement(
                'h2',
                null,
                'Tren\xE9\u0159i na t\xE1borech'
              ),
              _react2.default.createElement(
                'p',
                null,
                'I v tomto roce pojedou na t\xE1bory zku\u0161en\xED a obl\xEDben\xED tren\xE9\u0159i Tom\xE1\u0161 a Dominika. Na t\xE1bory s nimi pojedou i dal\u0161\xED instrukto\u0159i, kte\u0159\xED jsou vyb\xEDr\xE1ni podle zam\u011B\u0159en\xED t\xE1bora.'
              ),
              _react2.default.createElement(
                'a',
                { href: '/nas-tym#tomas-krupka', target: '_blank', className: (0, _classnames2.default)('col-xs-12 col-sm-4 col-lg-3 col-lg-offset-2', styles.instructor) },
                _react2.default.createElement('img', { src: instructors.tomas.photo }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Tom\xE1\u0161 ',
                  _react2.default.createElement(
                    'small',
                    null,
                    'Krupka'
                  )
                )
              ),
              _react2.default.createElement(
                'a',
                { href: '/nas-tym#dominika-krupkova', target: '_blank', className: (0, _classnames2.default)('col-xs-12 col-sm-4 col-lg-3', styles.instructor) },
                _react2.default.createElement('img', { src: instructors.dominika.photo }),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Dominika ',
                  _react2.default.createElement(
                    'small',
                    null,
                    'Krupkov\xE1'
                  )
                )
              )
            )
          )
        ),
        _Content2.default.renderDates(styles, data.dates, true)
      );
    }
  }]);
  return Camps;
}(_react.Component);

exports.default = Camps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camps/Camps.js
// module id = 1104
// module chunks = 0